import useSWR from 'swr';
import { getSettings, Settings } from '../api/settings';

export const useSettings = () => {
  const { data, error, mutate } = useSWR<Settings>('/settings', getSettings, {
    revalidateOnFocus: false
  });

  return {
    settings: data,
    isLoading: !error && !data,
    error,
    mutate
  };
};

